export default {
    loadingUserFile(state) {
        state.loading = true;
    },
    successUserFile(state, files) {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = files;
    },
    errorUserFile(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
        state.data = [];
    },
    resetSuccessUserFile(state) {
        state.success = false;
    },
};
